module.exports = __webpack_public_path__ + "media/luxury.4df6e4b6.jpg";